import React from "react";

// Column headers
const principles = ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P8", "P9"];

// Row data
const defaultReviewRows = [
  {
    subject: "1. Performance against above policy and follow up action",
    details: {},
  },
  {
    subject:
      "2. Meeting relevant legal requirements and correcting any violations.",
    details: {},
  },
];

const BoardReviewTable = ({ reviewData, setReviewData }) => {
  const handleInputChange = (rowIndex, principle, value) => {
    const updated = [...reviewData];
    updated[rowIndex].details[principle] = value;
    setReviewData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #000",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Subject for Review</th>
            <th
              colSpan={9}
              style={{
                ...tableHeaderStyle,
                textAlign: "center",
              }}
            >
              Indicate whether review was undertaken by Director / Committee of
              the Board / Any other Committee
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}></th>
            {principles.map((p) => (
              <th key={p} style={tableHeaderStyle}>
                {p}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reviewData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.subject}
              </td>
              {principles.map((principle) => (
                <td key={principle} style={tableCellStyle}>
                  <textarea
                    placeholder="Details"
                    value={row.details?.[principle] || ""}
                    onChange={(e) =>
                      handleInputChange(rowIndex, principle, e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default BoardReviewTable;
